import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PersonalPage from "../pages/personal/page";
import CorporatePage from "../pages/corporate/page";
import SelfEmployedPage from "../pages/self-employed/page";
import EnterprisePage from "../pages/enterprise/page";
import DailyPage from "../pages/daily/page";
import AdminPage from "../pages/admin/AdminPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/personal",
    element: <PersonalPage />,
  },
  {
    path: "/corporate",
    element: <CorporatePage />,
  },
  {
    path: "/self-employed",
    element: <SelfEmployedPage />,
  },
  {
    path: "/enterprise",
    element: <EnterprisePage />,
  },
  {
    path: "/daily",
    element: <DailyPage />,
  },
  {
    path: "/a",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;